<template>
    <v-dialog v-model="isActive" width="680" transition="dialog-bottom-transition" scrollable
        :fullscreen="$vuetify.breakpoint.mobile">
        <v-card class="rounded-0">
            <v-card flat class="rounded-0 ">
                <v-app-bar flat color="white" height="50">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" icon @click.outside="cerrarDialogo"
                                @keydown.esc="cerrarDialogo">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Cerrar</span>
                    </v-tooltip>
                    <v-toolbar-title class="font-weight-bold primary--text">{{ titulo }}</v-toolbar-title>
                </v-app-bar>
            </v-card>
            <v-card v-if="tipo == 'credencial'" flat>
                <div v-if="user.esjubilado">
                    <CredencialJubilado></CredencialJubilado>
                </div>
                <v-card-text v-else>
                    <CredencialAfiliado></CredencialAfiliado>
                </v-card-text>
            </v-card>
            <v-card v-if="tipo == 'constancia'" flat class="rounded-0 py-4">
                <ConstanciaConvenios></ConstanciaConvenios>
            </v-card>
            <v-card flat class="d-flex justify-center align-center rounded-0 py-2"
                :class="$vuetify.breakpoint.mdAndDown ? '' : ''">
                <v-btn elevation="0" @click="imprimirCredencial" width="370" color="primary" class="pa-5"
                    :disabled="loading" :loading="loading">
                    <v-icon class="mr-2">mdi-download</v-icon>descargar credencial
                </v-btn>
            </v-card>
        </v-card>
    </v-dialog>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import CredencialAfiliado from '@/components/cards/CredencialAfiliado.vue'
import CredencialJubilado from '@/components/cards/CredencialJubilado.vue'
import ConstanciaConvenios from '../cards/ConstanciaConvenios.vue';

export default {
    name: 'DialogoCard',

    components: {
        CredencialAfiliado,
        CredencialJubilado,
        ConstanciaConvenios
    },
    data() {
        return {
            isActive: false,
            url: '',
            show: false,
            loading: false,

            cabecera: [
                { text: 'APELLIDO', value: 'apellido', align: 'center', sortable: false },
                { text: 'NOMBRE', value: 'nombres', align: 'center', sortable: false },
                { text: 'Nº DOCUMENTO', value: 'nrodoc', align: 'center', sortable: false },
                { text: 'FECHA DE NACIMIENTO', value: 'fecnacim', align: 'center', sortable: false },
                { text: 'PARENTESCO', value: 'destipfamiliar', align: 'center', sortable: false },
                { text: 'ARCHIVOS', value: 'cantArchivos', align: 'center', width: '100px', sortable: false },

            ],
        }
    },
    props: ['titulo', 'tipo', 'width'],

    computed: {
        ...mapGetters('auth', ['user', 'nroafi']),
        ...mapGetters('dataUser', ['nroafi']),

        getColor: function () {
            return function (item) {
                switch (item.accion) {
                    case "M":
                        return 'warning'
                    case "X":
                        return 'gray'
                    case "B":
                        return 'error'
                    case "A":
                        return 'success'
                    default:
                        break;
                }
            }
        },
        getText: function () {
            return function (item) {
                switch (item.accion) {
                    case 'M':
                        return 'Modificado';
                    case 'X':
                        return 'Sin modificar';
                    case 'B':
                        return 'Eliminado';
                    case 'A':
                        return 'Nuevo';
                    default:
                        return 'S/E';
                }
            };
        }
    },
    methods: {
        ...mapActions('auth', ['generarCredencialAfiliado', 'generarCredencialJubilado', 'generarConstanciaConvenios']),

        cerrarDialogo() {
            this.isActive = false
        },
        abrirDialogo() {
            this.isActive = true
        },
        imprimirCredencial() {
            this.loading = true
            switch (this.tipo) {
                case 'credencial':
                    (this.user.esjubilado) ? this.generarCredencialJubilado().finally(() => this.loading = false) : this.generarCredencialAfiliado().finally(() => this.loading = false)
                    break;
                case 'constancia':
                    this.generarConstanciaConvenios().finally(() => this.loading = false)
                    break;
                default:
                    this.loading = false
                    break;
            }
        },
        formatDate(date) {
            if (!date) return null
            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
    }

}

</script>

<style>
.rounded-card {
    border-radius: 50px;
}
</style>